"use strict";

var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var API_KEY_TEMPLATE_PARAMETER = '{apiKey}';

/**  Token Contract  **/
/*
    Tokens recieved by this adapter from endpoints specified above must return in the following JSON format:
    {
        ValidTo: 'some date in UTC',
        TokenType: 'Bearer',
        IdToken: 'some long token'
    }
*/
var TokenRetrievalAdapter = /*#__PURE__*/function () {
  function TokenRetrievalAdapter(_ref) {
    var apiKey = _ref.apiKey,
      batchUrlTemplate = _ref.batchUrlTemplate;
    _classCallCheck(this, TokenRetrievalAdapter);
    this.apiKey = apiKey;
    this.batchUrlTemplate = batchUrlTemplate;
  }
  return _createClass(TokenRetrievalAdapter, [{
    key: "getBatchTokensByApiKey",
    value: function getBatchTokensByApiKey() {
      //resolve empty value if there is no api key - so we know to use the fallback method
      if (!this.apiKey) {
        return Promise.resolve();
      }
      var url = this.batchUrlTemplate.replace(API_KEY_TEMPLATE_PARAMETER, this.apiKey);
      return _axios["default"].get(url);
    }
  }]);
}();
module.exports = TokenRetrievalAdapter;